<template>
    <div id="hello">

        <div id="render-wrapper">
            <Render v-bind:isDay="isDay"></Render>
        </div>




            <h1 id="main-title">
                <span>BIURO SPRZEDAŻY</span>
            </h1>


        <section class="section">
        <div class="container" id="contact">
            <div class="columns">

                <div class="column is-one-twos"  style="text-align: center;">
                    <p>
                        Helvetia City sp. z o.o.<br>
                        ul. Jutrzenki 3/70<br>
20-538 Lublin
                        <br>
                        <br>
                        </p>
                        <p><span style="white-space: nowrap;">Poniedziałek – Piątek,</span> <span style="white-space: nowrap;">8:00 – 16:00</span></p>
                    
                    <p><a href="mailto:sprzedaz@kaczencova.pl"><font-awesome-icon icon="envelope" /> sprzedaz@kaczencova.pl</a></p>
                    <p><a href="tel:817108027"><font-awesome-icon icon="phone" /> 81 710 80 27</a></p>
                    <p><a href="tel:789151482"><font-awesome-icon icon="phone" /> 789 151 482 </a></p>
                    <br>
                    
                </div>

                <div class="column is-one-twos " style="text-align: center;">
                    <form @submit.prevent="submitForm">
    <div class="control"><input type="text" class="input" is-small v-model="name" placeholder="imię i nazwisko" style="width: 100%;"></div><br>
    <div class="control"><input type="email" class="input" is-small v-model="email" placeholder="Email"></div><br>
    <div class="control"><input type="text" class="input" is-small v-model="phone" placeholder="Telefon" style="width: 100%;"></div><br>
    <div class="control"><textarea v-model="message" class="textarea" placeholder="Wiadomość"></textarea></div><br>
    <div class="control"><button type="submit" is-small class="button">Wyślij</button></div>
    
  </form>
                </div>
            </div>
            <div class="columns">
                <div class="column is-full"  style="text-align: center;">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2498.389211707516!2d22.519787711759093!3d51.230326471633845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4722582a1e77b5cb%3A0x44f6173c87971685!2sJutrzenki%203%2F70%2C%2020-538%20Lublin!5e0!3m2!1spl!2spl!4v1715066545518!5m2!1spl!2spl" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" style="border:0; max-width: 100%; width: 100%; margin: 1em auto; filter: grayscale(100)" aria-hidden="false" tabindex="0"></iframe>

                </div>
            </div>

        </div>
        </section>

        <hr>

        <div id="content" style="padding-bottom: 4em;">

        </div>

    </div>
</template>

<script>
    import Render from "../components/Render";
    import Vue from 'vue'
    import { VueReCaptcha } from 'vue-recaptcha-v3'
    Vue.use(VueReCaptcha, { siteKey: '6Le8oAQoAAAAABgTrzXjcnP2sm9Vrn3sgS5yI2Fx' })



    export default {
        name: 'Contact',
        data() {
            return {
                isDay: false,
                name: '',
                email: '',
                message: '',
                phone: '',
                recaptchaToken: ''
            }
        },
        props: {
            msg: String
        },
        methods: {
            redirect(route) {
                this.$router.push(route);
            },
            async recaptcha() {
                // (optional) Wait until recaptcha has been loaded.
                await this.$recaptchaLoaded()

                // Execute reCAPTCHA with action "login".
                const token = await this.$recaptcha('login')
                this.recaptchaToken = token;

                console.log(token);
                console.log(this.recaptchaToken);

                // Do stuff with the received token.
                },
            async submitForm() {
                await this.$recaptchaLoaded()

                // Execute reCAPTCHA with action "login".
                const token = await this.$recaptcha('login')
                const formData = new FormData();
                formData.append('name', this.name);
                formData.append('email', this.email);
                formData.append('phone', this.phone);
                formData.append('message', this.message);
                formData.append('g-recaptcha-response', token);

                fetch('contact.php', {
                method: 'POST',
                body: formData
                })
                .then(response => response.json())
                .then(data => {
                alert(data.message);
                if(data.success) {
                    this.name = '';
                    this.email = '';
                    this.phone = '';
                    this.message = '';
                }
                })
                .catch((error) => {
                console.error('Error:', error);
                });
            }
        },

        components: {
            Render: Render
        }
    }
</script>

